import { Direction, ThumbRangeDaysWidth } from "./types";

export const MIN_THUMB_WIDTH = 80;

export const THUMB_RANGE_DAY_WIDTH_INITIAL_VALUE: ThumbRangeDaysWidth = {
  [Direction.Right]: { back: 0, forward: 0 },
  [Direction.Left]: { back: 0, forward: 0 }
};
